import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getStrategicPillar } from "../../redux/evaluacion_desempenio/StrategicPillar/actions";
import ImportObjectivesModal from "../../components/evaluacion_desempenio/EmployeeObjectives/ImportObjectivesModal";
import FirstPeriodRejectObjectivesModal from "../../components/evaluacion_desempenio/EmployeeObjectives/FirstPeriodRejectObjectivesModal";
import { approveObjectives, bossApprovesMidYear, bossCheckEmployeeObjective, bossRequireMidYearEdit, getEmployeeObjective, rejectObjectives, requireActionPlanMidYear, saveMultipleEmployeeObjective, sendFinalEvaluation, setObjectivesModified } from "../../redux/evaluacion_desempenio/EmployeeObjective/actions";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getEvaluationMonitorById } from "../../redux/evaluacion_desempenio/EvaluationMonitor/actions";
import { BOSS_ALLOWED_EDITING_STATUSES, canEdit, EMPLOYEE_ALLOWED_EDITING_STATUSES, EVALUATION_SPECIFIC_VIEWS, PERMISSIONS, QUARTERS, ROLES, STATUSES } from "./utils/Constants";
import SecondPeriodRejectObjectivesModal from "../../components/evaluacion_desempenio/EmployeeObjectives/SecondPeriodRejectObjectivesModal";
import { getObjectiveMetric } from "../../redux/evaluacion_desempenio/ObjectiveMetric/actions";
import { getBossCompetency, getEmployeeCompetency } from "../../redux/evaluacion_desempenio/EvaluationCompetency/actions";
import { getFormType } from "../../redux/evaluacion_desempenio/FormType/actions";
import { getBossValue, getEmployeeValue } from "../../redux/evaluacion_desempenio/EvaluationValue/actions";
import ValueEvaluationForm from "../../components/evaluacion_desempenio/EmployeeObjectives/ValueEvaluationForm";
import CompetencyEvaluationForm from "../../components/evaluacion_desempenio/EmployeeObjectives/CompetencyEvaluationForm";
import ObjectiveEvaluationForm from "../../components/evaluacion_desempenio/EmployeeObjectives/ObjectiveEvaluationForm";


const EmployeeObjectives = (props) => {
    const [show, setShow] = useState(false);
    const dispatch = useDispatch()
    const [showImportModal, setShowImportModal] = useState(false);
    const [showFirstPeriodRejectModal, setShowFirstPeriodRejectModal] = useState(false);

    const { idEvaluacion, idConfiguracion, idEvaluacionGeneral } = useParams();
    const [showSecondPeriodRejectModal, setShowSecondPeriodRejectModal] = useState(false);
    const [secondPeriodActionType, setSecondPeriodActionType] = useState('reject'); // 'reject' or 'approve'
    const onShowSidebar = () => setShow(show ? false : true);

    const [objectivesEvaluationReady, setObjectivesEvaluationReady] = useState(false);
    const [valuesEvaluationReady, setValuesEvaluationReady] = useState(false);
    const [competenciesEvaluationReady, setCompetenciesEvaluationReady] = useState(false);

    const [evaluationRole, setEvaluationRole] = useState(null);

    const {
        loading,
        saveLoading,
        employeeObjectivesLength,
        employeeObjectives,
        employeeObjectiveError,
        formError,
        objectivesModified
    } = useSelector((store) => store.employeeObjective);

    const {
        loadingById: loadingEvaluationMonitor,
        evaluationMonitor,
        evaluationMonitorError
    } = useSelector((store) => store.evaluationMonitor);

    const {
        loading: loadingFormType,
        formTypes,
        formTypesLength,
        formTypeError
    } = useSelector((store) => store.formType);

    //Obtener los tipos de formulario para saber si la evaluación incluye evaluación por competencias o por valores
    const competencyEvaluationId = formTypes?.find(ft => ft?.nombre?.toLowerCase().includes("competencias"))?.id;
    const valueEvaluationId = formTypes?.find(ft => ft?.nombre?.toLowerCase().includes("valores"))?.id;
    const isCompetencyEval = evaluationMonitor?.data_evaluacion_objetivos?.formularios?.some(ft => ft.formulario__id === competencyEvaluationId);
    const isValueEval = evaluationMonitor?.data_evaluacion_objetivos?.formularios?.some(ft => ft.formulario__id === valueEvaluationId)

    const { id: idUser, userRoles } = useSelector((store) => store.auth);
    const evaluationEtapa = evaluationMonitor?.data_evaluacion_objetivos?.etapa;


     // Determinar si el usuario ya ha enviado la evaluación en el 3Q
    const evaluationDone = STATUSES.PENDIENTE_EVALUACION &&
        ((evaluationMonitor?.data_evaluacion_objetivos?.jefe_completo_evaluacion && idUser === evaluationMonitor?.evaluador) ||
            (evaluationMonitor?.data_evaluacion_objetivos?.empleado_completo_evaluacion && idUser === evaluationMonitor?.evaluado));

    useEffect(() => {
        dispatch(getStrategicPillar({
            configuracion: idConfiguracion
        }));
        dispatch(getEmployeeObjective({
            empleado_evaluacion: idEvaluacion
        }))
        dispatch(getEvaluationMonitorById(idEvaluacionGeneral))
        dispatch(getObjectiveMetric({ configuracion: idConfiguracion }))
        dispatch(getFormType())
    }, [])

    useEffect(() => {
        if (evaluationMonitor && idUser && userRoles) {
            if (evaluationMonitor?.evaluado === idUser) {
                setEvaluationRole(ROLES.EMPLOYEE)
            } else if (evaluationMonitor?.evaluador === idUser) {
                setEvaluationRole(ROLES.BOSS)
            } else if (userRoles.includes('administrador')) {
                setEvaluationRole(ROLES.ADMIN)
            }
        }
    }, [evaluationMonitor, idUser, userRoles])

    useEffect(() => {
        if (!evaluationMonitor) return;

        const etapa = evaluationMonitor?.data_evaluacion_objetivos?.etapa;
        const canCallEvaluationData = etapa === STATUSES.PENDIENTE_EVALUACION || etapa === STATUSES.PENDIENTE_CERRAR_EVALUACION || etapa === STATUSES.EVALUACION_COMPLETADA;

        if (canCallEvaluationData) {
            if (evaluationMonitor?.evaluado === idUser) {
                if (isCompetencyEval) {
                    dispatch(getEmployeeCompetency({ evaluacion_empleado: idEvaluacion }));
                }
                if (isValueEval) {
                    dispatch(getEmployeeValue({ evaluacion_empleado: idEvaluacion }));
                }
            } else if (evaluationMonitor?.evaluador === idUser) {
                if (isCompetencyEval) {
                    dispatch(getEmployeeCompetency({ evaluacion_empleado: idEvaluacion }));
                    dispatch(getBossCompetency({ evaluacion_empleado: idEvaluacion }));
                }
                if (isValueEval) {
                    dispatch(getEmployeeValue({ evaluacion_empleado: idEvaluacion }));
                    dispatch(getBossValue({ evaluacion_empleado: idEvaluacion }));
                }
            }
        }

    }, [evaluationMonitor, formTypes])


    const handleHistory = () => {
        // Navegar a la página de historial de cambios
        props.history.push(`/evaluacion-desempenio/formulario-por-objetivos/historial/${idEvaluacion}`);
    }


    const handleImportObjectives = (objetivos) => {
        if (objetivos.length > 0) {
            dispatch(saveMultipleEmployeeObjective(objetivos, idConfiguracion, idEvaluacion));
        }
    };



    //Función para que el empleado envíe sus objetivos a revisión del jefe
    const handleBossCheck = async () => {
        if (!window.confirm("¿Está seguro de enviar la evaluación a revisión?")) return;
        await dispatch(bossCheckEmployeeObjective({
            evaluacion_empleado: Number(idEvaluacion),
            id_empleado: evaluationMonitor?.evaluado
        },
            {
                empleado_evaluacion: idEvaluacion
            }))
        dispatch(setObjectivesModified(false));
        //se vuelve a cargar el estado de la evaluación para actualizar la etapa
        await dispatch(getEvaluationMonitorById(idEvaluacionGeneral))
    }

    const approveOrRejectObjectives = async (isApproved, comment = "") => {
        let confirmMessage = isApproved ? "¿Está seguro de aprobar los objetivos?" : "¿Está seguro de rechazar los objetivos?";
        if (!window.confirm(confirmMessage)) return;
        const data = {
            evaluacion_empleado: Number(idEvaluacion),
            id_empleado: evaluationMonitor?.evaluado,
        };
        if (!isApproved) {
            data.comentario = comment;
            await dispatch(rejectObjectives(data));
        } else {
            await dispatch(approveObjectives(data));
        }

        //se vuelve a cargar el estado de la evaluación para actualizar la etapa
        await dispatch(getEvaluationMonitorById(idEvaluacionGeneral))
    }



    const handleBossCheckSecondPeriod = async (comment, includeActionPlan) => {
        let req = {
            comentario_mitad_anio: comment,
        }
        if (secondPeriodActionType === 'reject') {
            await dispatch(bossRequireMidYearEdit(req, idEvaluacion))
        } else {
            await dispatch(bossApprovesMidYear(req, idEvaluacion))
        }
        if (includeActionPlan) {
            await dispatch(requireActionPlanMidYear({ cargar_plan_accion: true }, idEvaluacion))
        }
        await dispatch(getEvaluationMonitorById(idEvaluacionGeneral))

    }


    const handleSendFinalEvaluation = async () => {
        if (!window.confirm("¿Está seguro de enviar la evaluación?")) return;

        let req = {}
        if (idUser === evaluationMonitor?.evaluado) req.empleado = true;
        else if (idUser === evaluationMonitor?.evaluador) req.jefe = true;
        await dispatch(sendFinalEvaluation(req, idEvaluacion))
        //se vuelve a cargar el estado de la evaluación para actualizar la etapa
        await dispatch(getEvaluationMonitorById(idEvaluacionGeneral))

    }

    return (
        <>
            <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
            <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
            <div className="custom-wrapper">
                <Container fluid>
                    <h3>Formulario por Objetivos</h3>
                    <hr />
                    <div className="p-4 border-left border-warning">
                        <Row>
                            <Col md={9}>
                                <p>
                                    DEBE INDICAR LOS OBJETIVOS ESTRATÉGICOS, OBJETIVO, PESO E INDICADOR.
                                </p>
                            </Col>
                            <Col md={3}>
                                {
                                    //El empleado solamente puede enviar la evaluación a revisión si la suma de los pesos es 100 y si el estado de la evaluación es uno que le permite editar
                                    (employeeObjectives.reduce(
                                        (acc, obj) => acc + (parseFloat(obj.peso) || 0),
                                        0
                                    ) === 100) && canEdit(evaluationRole, [QUARTERS.FIRST, QUARTERS.SECOND], evaluationEtapa, null, EVALUATION_SPECIFIC_VIEWS.EMPLOYEE_SEND_EVALUATION) && objectivesModified ? (
                                        <Button
                                            variant="primary"
                                            className="rounded-pill"
                                            onClick={handleBossCheck}
                                            disabled={loading || saveLoading || loadingEvaluationMonitor}
                                        >
                                            {(loading || loadingEvaluationMonitor) && (
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    className="mr-2"
                                                />
                                            )} ENVIAR A REVISIÓN
                                        </Button>

                                    ) : null
                                }
                                {
                                    console.log(objectivesEvaluationReady, ( valuesEvaluationReady), (!isCompetencyEval || competenciesEvaluationReady), canEdit(evaluationRole, [QUARTERS.THIRD], evaluationEtapa, { condition: !evaluationDone, quarter: QUARTERS.THIRD }))
                                }
                                {
                                    //El empleado puede enviar la evaluación final si todas las secciones están listas y si el estado de la evaluación es uno que le permite editar
                                    (objectivesEvaluationReady && (!isValueEval || valuesEvaluationReady) && (!isCompetencyEval || competenciesEvaluationReady)) && canEdit(evaluationRole, [QUARTERS.THIRD], evaluationEtapa, { condition: !evaluationDone, quarter: QUARTERS.THIRD }) ? (
                                        <Button
                                            variant="primary"
                                            className="rounded-pill"
                                            onClick={handleSendFinalEvaluation}
                                            disabled={loading || saveLoading || loadingEvaluationMonitor}
                                        >
                                            {(loading || loadingEvaluationMonitor) && (
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    className="mr-2"
                                                />
                                            )} ENVIAR EVALUACIÓN
                                        </Button>
                                    ) : null
                                }
                                {
                                    //El jefe solamente puede aprobar o rechazar los objetivos si el estado de la evaluación es uno que le permite editar
                                    canEdit(evaluationRole, [QUARTERS.FIRST, QUARTERS.SECOND], evaluationEtapa, null, EVALUATION_SPECIFIC_VIEWS.BOSS_ACCEPT_OBJECTIVES) ? (
                                        <>
                                            <Button
                                                variant="danger"
                                                className="rounded-pill mr-2"
                                                onClick={() => setShowFirstPeriodRejectModal(true)}
                                                disabled={loading || loadingEvaluationMonitor}
                                            >
                                                {(loading || loadingEvaluationMonitor) && (
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        className="mr-2"
                                                    />
                                                )}
                                                AJUSTAR
                                            </Button>
                                            <Button
                                                variant="success"
                                                className="rounded-pill"
                                                onClick={() => approveOrRejectObjectives(true)}
                                                disabled={loading || loadingEvaluationMonitor}
                                            >
                                                {(loading || loadingEvaluationMonitor) && (
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        className="mr-2"
                                                    />
                                                )}
                                                APROBAR
                                            </Button>
                                        </>
                                    ) : null
                                }

                                {/* //Botones para la revisión de mitad de año del jefe */}
                                {
                                    evaluationMonitor?.data_evaluacion_objetivos?.etapa === STATUSES.PENDIENTE_REVISION && evaluationMonitor?.evaluador === idUser && (
                                        <div>
                                            <Button
                                                disabled={loading || loadingEvaluationMonitor}
                                                onClick={() => {
                                                    setSecondPeriodActionType('reject');
                                                    setShowSecondPeriodRejectModal(true);

                                                }}
                                                className="rounded-pill mt-2"
                                                variant="danger"
                                            >
                                                {(loading || loadingEvaluationMonitor) && (
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        className="mr-2"
                                                    />
                                                )}

                                                Solicitud Ajuste
                                            </Button>
                                            <Button
                                                disabled={loading || loadingEvaluationMonitor}
                                                onClick={() => {
                                                    setSecondPeriodActionType('approve');
                                                    setShowSecondPeriodRejectModal(true);
                                                }}
                                                className="rounded-pill mt-2 ml-2"
                                                variant="success"
                                            >
                                                {(loading || loadingEvaluationMonitor) && (
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        className="mr-2"
                                                    />
                                                )}
                                                Sin Ajustes
                                            </Button>
                                        </div>
                                    )
                                }


                            </Col>
                        </Row>
                    </div>
                    <hr />
                    <ObjectiveEvaluationForm
                        idUser={idUser}
                        evaluationRole={evaluationRole}
                        handleHistory={handleHistory}
                        setShowImportModal={setShowImportModal}
                        setObjectivesEvaluationReady={setObjectivesEvaluationReady}
                    />

                    {isValueEval && Object.keys(PERMISSIONS[QUARTERS.THIRD]).includes(evaluationMonitor?.data_evaluacion_objetivos?.etapa) && (
                        <ValueEvaluationForm
                            evaluationEtapa={evaluationEtapa}
                            evaluationRole={evaluationRole}
                            idUser={idUser}
                            setValuesEvaluationReady={setValuesEvaluationReady}
                        />
                    )}

                    {isCompetencyEval && Object.keys(PERMISSIONS[QUARTERS.THIRD]).includes(evaluationMonitor?.data_evaluacion_objetivos?.etapa) && (
                        <CompetencyEvaluationForm
                            evaluationEtapa={evaluationEtapa}
                            evaluationRole={evaluationRole}
                            idUser={idUser}
                            setCompetenciesEvaluationReady={setCompetenciesEvaluationReady}
                        />
                    )}


                    < ImportObjectivesModal
                        showFormModal={showImportModal}
                        setShowFormModal={setShowImportModal}
                        onImportObjectives={handleImportObjectives}
                    />
                    <FirstPeriodRejectObjectivesModal
                        showFormModal={showFirstPeriodRejectModal}
                        setShowFormModal={setShowFirstPeriodRejectModal}
                        onReject={approveOrRejectObjectives}
                    />
                    <SecondPeriodRejectObjectivesModal
                        showFormModal={showSecondPeriodRejectModal}
                        setShowFormModal={setShowSecondPeriodRejectModal}
                        onSubmit={handleBossCheckSecondPeriod}
                        type={secondPeriodActionType}
                    />


                </Container>

            </div>
        </>

    )

}

export default EmployeeObjectives